import { render, staticRenderFns } from "./openRecordList.vue?vue&type=template&id=f8dd6fe0&scoped=true&"
import script from "./openRecordList.vue?vue&type=script&lang=js&"
export * from "./openRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dd6fe0",
  null
  
)

export default component.exports